module.exports = __webpack_public_path__ + "media/country_flags/ao-432da73f.png";